import React, { Component } from "react";
import styles from "./Announcement.module.scss";
import AnnouncementDialogDelete from "./AnnouncementDialogDelete";
import AnnouncementDialogEdit from "./AnnouncementDialogEdit";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../common/HasPermissionTo";

class AnnouncementBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openEditModal: false,
      openDeleteModal: false,
    };
  }

  toggleEditModal = () => {
    this.setState((prevState) => ({
      openEditModal: !prevState.openEditModal,
    }));
  };

  toggleDeleteModal = () => {
    this.setState((prevState) => ({
      openDeleteModal: !prevState.openDeleteModal,
    }));
  };

  render() {
    return (
      <div className={styles.border}>
        <div className={styles.bodyContainer}>
          <div className={styles.announcementDescription}>
            {this.props.announcement.announcement}
          </div>
          <HasPermissionTo
            perform={["nscAnnouncement:write"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => (
              <div className={styles.editDeleteContainer}>
                <span onClick={this.toggleEditModal}>
                  {this.props.t("Announcement.editBtn")}
                </span>
                <span>&nbsp;|&nbsp;</span>
                <span onClick={this.toggleDeleteModal}>
                  {this.props.t("Announcement.deleteBtn")}
                </span>
              </div>
            )}
          />
          <AnnouncementDialogEdit
            open={this.state.openEditModal}
            closeModal={this.toggleEditModal}
            id={this.props.announcement.id}
            description={this.props.announcement.announcement}
            user={this.props.user}
            selectedMarket={this.props.selectedMarket}
            getAnnouncements={this.props.getAnnouncements}
            maxlength={this.props.maxlength}
            t={this.props.t}
          />
          <AnnouncementDialogDelete
            open={this.state.openDeleteModal}
            closeModal={this.toggleDeleteModal}
            id={this.props.announcement.id}
            user={this.props.user}
            getAnnouncements={this.props.getAnnouncements}
            t={this.props.t}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation("emp")(AnnouncementBody);
